import http from '@/plugins/axios/axios';

export default class FeriadoService {

    salvar(requisicao) {       
        return http.post('/api/feriado/salvar', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/feriado/excluir', requisicao);
    }

    copiar(requisicao) {       
        return http.post('/api/feriado/copiar', requisicao);
    }

    buscar(requisicao) {       
        return http.post('/api/feriado/buscar', requisicao);
    }

    listar(requisicao) {       
        return http.post('/api/feriado/listar', requisicao);
    }

    listarEstados() {        
        return http.get('/api/feriado/listar-estados');
    }

    listarCidades(idEstado) {       
        return http.get('/api/feriado/listar-cidades/'+idEstado);
    }
}